import { createContext } from 'react';
import { IToastConfig } from 'interfaces/ToastConfig';

export const ToastContext = createContext<IToastConfig>(null!);
